(function () {
  'use strict';

  var SLOT_SELECTOR = '[data-pdp-combination-slot]';
  var MAX_PRODUCTS = 2;

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function formatMoney(cents) {
    if (window.formatMoney && window.theme) {
      return window.formatMoney(cents, window.theme.moneyWithCurrencyFormat);
    }

    return 'Rs. ' + (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' INR';
  }

  function availableVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find(function (variant) { return variant.available; }) || null;
  }

  function productImage(product) {
    var media = Array.isArray(product.media) ? product.media.filter(function (item) {
      return item.media_type === 'image' && item.src;
    }) : [];

    var preferred = media.find(function (item) {
      return item.position > 1 && item.aspect_ratio >= 0.75 && item.aspect_ratio <= 1.5;
    }) || media.find(function (item) {
      return item.aspect_ratio >= 0.75 && item.aspect_ratio <= 1.5;
    }) || media[0];

    var source = preferred ? preferred.src : product.featured_image;
    if (!source) return '';
    if (source.indexOf('//') === 0) source = 'https:' + source;

    try {
      var url = new URL(source, window.location.origin);
      url.searchParams.set('width', '400');
      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function recommendationUrl(productId) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) +
      '&limit=' + MAX_PRODUCTS + '&intent=complementary';
  }

  function currentVariantData(root, form) {
    var idInput = form.querySelector('input[name="id"]');
    var currentId = idInput ? Number(idInput.value) : 0;
    var variantsElement = root.querySelector('[data-pdp-variants]');
    if (!variantsElement) return null;

    try {
      var variants = JSON.parse(variantsElement.textContent);
      return variants.find(function (variant) { return Number(variant.id) === currentId; }) || null;
    } catch (error) {
      return null;
    }
  }

  function currentPrice(root, form) {
    var variant = currentVariantData(root, form);
    return variant ? Number(variant.price_cents) : 0;
  }

  function buildCurrentItem(form) {
    var data = new FormData(form);
    var item = {
      id: Number(data.get('id')),
      quantity: Number(data.get('quantity') || 1)
    };
    var properties = {};

    data.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });

    if (Object.keys(properties).length) item.properties = properties;
    if (data.get('selling_plan')) item.selling_plan = Number(data.get('selling_plan'));
    return item;
  }

  function buildCard(product, variant, index) {
    var card = element('article', 'anthropoiid-pdp-combination__card');
    card.setAttribute('data-combination-card', '');
    card.dataset.variantId = variant.id;
    card.dataset.price = variant.price;

    var input = element('input', 'anthropoiid-pdp-combination__input');
    var inputId = 'PdpCombination-' + product.id + '-' + index;
    input.type = 'checkbox';
    input.id = inputId;
    input.setAttribute('data-combination-input', '');
    input.setAttribute('aria-label', 'Add ' + product.title + ' for ' + formatMoney(variant.price));

    var label = element('label', 'anthropoiid-pdp-combination__label');
    label.htmlFor = inputId;
    var check = element('span', 'anthropoiid-pdp-combination__check');
    check.setAttribute('aria-hidden', 'true');

    var imageStage = element('span', 'anthropoiid-pdp-combination__image-stage');
    var image = element('img', 'anthropoiid-pdp-combination__image');
    image.src = productImage(product);
    image.alt = product.title;
    image.loading = 'lazy';
    image.width = 400;
    image.height = 320;
    imageStage.appendChild(image);

    var copy = element('span', 'anthropoiid-pdp-combination__copy');
    copy.appendChild(element('span', 'anthropoiid-pdp-combination__name', product.title));
    copy.appendChild(element('span', 'anthropoiid-pdp-combination__price', '+ ' + formatMoney(variant.price)));

    label.appendChild(check);
    label.appendChild(imageStage);
    label.appendChild(copy);
    card.appendChild(input);
    card.appendChild(label);

    var viewLink = element('a', 'anthropoiid-pdp-combination__view', 'View piece');
    viewLink.href = product.url;
    viewLink.setAttribute('aria-label', 'View ' + product.title + ' details');
    card.appendChild(viewLink);
    return card;
  }

  function renderModule(slot, products) {
    var module = element('section', 'anthropoiid-pdp-combination');
    module.setAttribute('aria-labelledby', 'PdpCombinationHeading-' + slot.dataset.productId);
    module.setAttribute('data-pdp-combination', '');

    module.appendChild(element('div', 'anthropoiid-pdp-combination__kicker', 'Pairs with / Optional'));

    var headingRow = element('div', 'anthropoiid-pdp-combination__heading-row');
    var heading = element('h2', 'anthropoiid-pdp-combination__heading', 'Add complementary pieces');
    heading.id = 'PdpCombinationHeading-' + slot.dataset.productId;
    var count = element('span', 'anthropoiid-pdp-combination__count', '0 selected');
    count.setAttribute('data-combination-count', '');
    headingRow.appendChild(heading);
    headingRow.appendChild(count);
    module.appendChild(headingRow);

    module.appendChild(element(
      'p',
      'anthropoiid-pdp-combination__help',
      'Select one or both to add with ' + slot.dataset.productTitle + '.'
    ));

    var grid = element('div', 'anthropoiid-pdp-combination__grid');
    if (products.length === 1) grid.classList.add('is-single');
    products.forEach(function (entry, index) {
      grid.appendChild(buildCard(entry.product, entry.variant, index));
    });
    module.appendChild(grid);

    var summary = element('div', 'anthropoiid-pdp-combination__summary');
    summary.appendChild(element(
      'span',
      'anthropoiid-pdp-combination__summary-label',
      'With selected additions'
    ));
    var total = element('strong', 'anthropoiid-pdp-combination__total');
    total.setAttribute('data-combination-total', '');
    total.setAttribute('aria-live', 'polite');
    summary.appendChild(total);
    module.appendChild(summary);

    var error = element('p', 'anthropoiid-pdp-combination__error');
    error.setAttribute('data-combination-error', '');
    error.setAttribute('role', 'alert');
    error.hidden = true;
    module.appendChild(error);
    slot.appendChild(module);
    return module;
  }

  function initModule(slot, module, form, root) {
    var inputs = Array.prototype.slice.call(module.querySelectorAll('[data-combination-input]'));
    var count = module.querySelector('[data-combination-count]');
    var total = module.querySelector('[data-combination-total]');
    var error = module.querySelector('[data-combination-error]');
    var addText = root.querySelector('[data-pdp-add-text]');
    var mobilePrice = root.querySelector('.anthropoiid-pdp-mbar [data-pdp-price]');

    function selectedCards() {
      return inputs.filter(function (input) { return input.checked; }).map(function (input) {
        return input.closest('[data-combination-card]');
      });
    }

    function updatePricing() {
      var selected = selectedCards();
      var combinedPrice = selected.reduce(function (sum, card) {
        return sum + Number(card.dataset.price);
      }, currentPrice(root, form));

      inputs.forEach(function (input) {
        input.closest('[data-combination-card]').classList.toggle('is-selected', input.checked);
      });
      count.textContent = selected.length + ' selected';
      total.textContent = formatMoney(combinedPrice);
      if (addText) addText.textContent = 'Add to bag \u2014 ' + formatMoney(combinedPrice);
      if (mobilePrice) mobilePrice.textContent = formatMoney(combinedPrice);
    }

    inputs.forEach(function (input) { input.addEventListener('change', updatePricing); });
    root.querySelectorAll('[data-pdp-option]').forEach(function (option) {
      option.addEventListener('change', function () { window.setTimeout(updatePricing, 0); });
    });
    updatePricing();

    form.addEventListener('submit', function (event) {
      var selected = selectedCards();
      if (!selected.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      error.hidden = true;

      var items = [buildCurrentItem(form)].concat(selected.map(function (card) {
        return { id: Number(card.dataset.variantId), quantity: 1 };
      }));
      var addButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-add]'));
      var previousStates = addButtons.map(function (button) { return button.disabled; });
      addButtons.forEach(function (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      });

      var isDrawer = window.theme && window.theme.settings && window.theme.settings.cart_type === 'drawer';
      var sections = isDrawer
        ? 'drawer-cart-items,drawer-cart-footer,cart-item-count'
        : 'cart-item-count';
      var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';

      fetch(cartUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: items,
          sections: sections,
          sections_url: window.location.pathname
        })
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message || 'Unable to add this combination.');
          document.body.dispatchEvent(new CustomEvent('switch:cart:afteradditem', {
            bubbles: true,
            detail: { response: data }
          }));
        })
        .catch(function (requestError) {
          error.textContent = requestError.message || 'Unable to add this combination. Please try again.';
          error.hidden = false;
        })
        .finally(function () {
          addButtons.forEach(function (button, index) {
            button.disabled = previousStates[index];
            button.removeAttribute('aria-busy');
          });
        });
    }, true);
  }

  function initSlot(slot) {
    var form = document.getElementById(slot.dataset.formId);
    var root = slot.closest('[data-product-section]');
    if (!form || !root || !slot.dataset.productId) return;

    fetch(recommendationUrl(slot.dataset.productId), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations unavailable');
        return response.json();
      })
      .then(function (data) {
        var products = Array.isArray(data.products) ? data.products.map(function (product) {
          return { product: product, variant: availableVariant(product) };
        }).filter(function (entry) {
          return entry.variant && productImage(entry.product);
        }).slice(0, MAX_PRODUCTS) : [];

        if (!products.length) return;
        root.querySelectorAll('[data-pdp-option-name="configuration"]').forEach(function (option) {
          option.hidden = true;
        });
        initModule(slot, renderModule(slot, products), form, root);
      })
      .catch(function () {
        // Recommendations are optional. A failed or empty response leaves the PDP unchanged.
      });
  }

  function init() {
    document.querySelectorAll(SLOT_SELECTOR).forEach(initSlot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
